import React, { useState, useEffect } from "react";
import CustomTable from "../../../../customComponents/CustomTable";
// import './index.scss';
import editIcon from "./../../../../../Assets/icons/Un-Checkbox.svg";
import DownloadSVG from "./../../../../../Assets/icons/DownloadIconMIS.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import Loader from "../../../../customComponents/CustomLoader";
import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
// import ProductTable from './ProductTable';
import { FiDownload } from "react-icons/fi";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";

const StockIn = () => {
  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [filters, setFilters] = useState({});
  const [totalActive, setTotalActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalInactive, setTotalInactive] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [variantOptions, setVariantOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  const fetchProductList = async (page = 0, pageSize = 10) => {
    try {
      const allfilteredData = filters;

      setLoading(true);
      const response = await axiosInstance.post(
        "/instock/stock-upload-history",
        {
          // orderBy: 'product_id desc',
          page,
          pageSize,
          searchText: searchTerm,
          variant_id: allfilteredData?.variantId
            ? allfilteredData?.variantId
            : null,
          stateId: allfilteredData?.stateId ? allfilteredData?.stateId : null,
          // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
          // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,
          startDate: formatDate(allfilteredData?.fromDate),
          endDate: formatDate(allfilteredData?.toDate),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 + page * pageSize,
        itemtype_id: item.itemtype_id === 3 ? "Vehicle" : item.itemtype_id === 1 ? "Spare Part" : item.itemtype_id === 2 ? "Accessories" : "--",
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductData = async () => {
    const allfilteredData = filters;
    const payload = {
      // business_partner_id: 1,
      // dealerId: dealerId || "",
      //   dealerId: allfilteredData?.dealerId? allfilteredData?.dealerId :null,
      //   // fromDate:"",
      //   // toDate:"",
      //   state_id:"",
      //   services_by:"",
      //   servicesValue_Id:"",
      //   orderBy:"po_id desc",
      //  toDate:"",
      // fromDate:"",
      // page: 0,
      // pageSize: 10,
      // searchText: "",
      // orderBy: "loginHistoryId desc",
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      orderBy: "",
    };
    console.log("filteresdata", payload);

    try {
      // setTableLoader(true)
      const response = await axiosInstance.post(
        "/product/product-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // setTableLoader(false)
      // const formattedData = response?.data?.data?.data.map((item, index) => ({
      //     ...item,
      //     item_name: item.item_name || "--",
      //     model_name: item.model_name || "--",
      //     variant_name: item.variant_name || "--",
      //     logInDateTime: item.logInDateTime
      //     ? new Date(item.logInDateTime)
      //         .toLocaleString("en-GB", { hour12: false }) // 24-hour format
      //         .replace(/\//g, "-") // Convert date separator to "-"
      //     : "--"

      // }))
      // const totalRecordsData = response?.data?.data?.totalRecords
      // setTotalRecords(totalRecordsData);

      // setVinNoData(formattedData)
    } catch (error) {
      console.error("Error fetching business partners:", error);
      // setIsSearchPerformed(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductList(newPage);
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      orderBy: "",
    };

    try {
      const response = await axiosInstance.post(
        "/product/product-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "product.csv";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  const TABLE_HEADERS = [
    // "Sr No.",
    // "Product ID",
    "Item Type",
    "Model Name",
    "Color Name",
    "Variant Name",
    "Item Name",
    "Quantity",
    "Created On",
    // "Status",
    // "Action",
  ];

  const keyMapping = {
    // "Sr No.": "Sr No.",
    // "Product ID": "product_id",
    // "Name": "product_name",
    "Item Type": "itemtype_id",
    "Model Name": "model_name",
    "Color Name": "color_name",
    "Variant Name": "variant_name",
    "Item Name": "item_name",
    Quantity: "quantity",
    "Created On": "created_at",
    // "Status": "is_active",
    // "Action": "action",
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchProductList();
    }
  }, [searchTerm]);
  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.EDITPRODUCT}`, { state: { data: rowData } });
  };

  const PhysicalStockTakingInputs = [
    {
      // name: "variant",
      name: "variantId",
      label: "Variant",
      placeholder: "Select Variant",
      type: "dropdown",
      options: variantOptions,
      // required: true,
      gridClass: "col-lg-3",
      // validation: { required: true },
    },
    {
      name: "fromDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-3",
    },
    {
      name: "toDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-3",
    },
  ];

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.fromDate || null,
      toDate: filterFormData.toDate || null,
      modelId: filterFormData?.modelId ? filterFormData?.modelId : null,
      variantId: filterFormData?.variantId ? filterFormData?.variantId : null,
      dealerId: filterFormData?.dealerId ? filterFormData?.dealerId : null,
      colorId: filterFormData?.colorId || null,
    });
  };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    // fetchJobCardList();
  };

  useEffect(() => {
    fetchProductList();
  }, [filters]);

  useEffect(() => {
    fetchVariantOptions();
  }, []);

  const fetchVariantOptions = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="OnboardManagamentContainer">
              <div className="OnboardManagamentbuttonContainer">
                <h5>Stock-In Management</h5>
              </div>
              <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
                {/* <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                  <h5 className="listTopDataValueText" >{totalData} </h5>
                  <h6>All Product</h6>
                </div>
                <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                  <h5 className="listTopDataValueText" >{totalActive} </h5>
                  <h6>Active Product</h6>
                </div>
                <div className='topleftdataContainer'>
                  <h5 className="listTopDataValueText" >{totalInactive} </h5>
                  <h6>Inactive Product</h6>
                </div> */}
                <button
                  className="addcustomerbutton"
                  onClick={() =>
                    navigate("/admin/manage-product/stock-in/add-stock-in")
                  }
                >
                  Add Stock In
                </button>
              </div>
            </div>
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
            />
            <div className="tableWrapper">
              <div className="admin-list-container">
                <div className="listsearchContainer">
                  <h4>Stock-In List</h4>
                  <div>
                    {/* <SearchInput
                      placeholder="Search Item"
                      onSearch={fetchProductList}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    /> */}
                  </div>
                  {/* <div
                    onClick={downloadExcel}
                    className="flte-btnnn"
                    style={{ borderRadius: "38px", cursor: "pointer" }}
                  >
                    Export
                    <span>
                      <FiDownload
                        className="downloadexcel-misreportsales"
                        style={{ cursor: "pointer" }}
                        size={22}
                      />
                    </span>
                  </div> */}
                </div>
              </div>
              <CustomTable
                data={productData}
                headers={TABLE_HEADERS}
                keyMapping={keyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEdit}
                totalRecords={totalRecords}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default StockIn;
